/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { CameraSettings, PhotoSettings } from "../../mission_camera_settings";

export const protobufPackage = "skills";

export interface TakePanoramaActionArgs {
  /** Mode for taking a panorama. */
  panoramaMode: PanoramaMode_Enum;
  /** General camera settings like exposure time, iso, etc. */
  cameraSettings:
    | CameraSettings
    | undefined;
  /** Photo specific settings */
  photoSettings: PhotoSettings | undefined;
}

export interface PanoramaMode {
}

export enum PanoramaMode_Enum {
  UNSPECIFIED = 0,
  HORIZONTAL = 1,
  VERTICAL = 2,
  SPHERE = 3,
  UNRECOGNIZED = -1,
}

export function panoramaMode_EnumFromJSON(object: any): PanoramaMode_Enum {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return PanoramaMode_Enum.UNSPECIFIED;
    case 1:
    case "HORIZONTAL":
      return PanoramaMode_Enum.HORIZONTAL;
    case 2:
    case "VERTICAL":
      return PanoramaMode_Enum.VERTICAL;
    case 3:
    case "SPHERE":
      return PanoramaMode_Enum.SPHERE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PanoramaMode_Enum.UNRECOGNIZED;
  }
}

export function panoramaMode_EnumToJSON(object: PanoramaMode_Enum): string {
  switch (object) {
    case PanoramaMode_Enum.UNSPECIFIED:
      return "UNSPECIFIED";
    case PanoramaMode_Enum.HORIZONTAL:
      return "HORIZONTAL";
    case PanoramaMode_Enum.VERTICAL:
      return "VERTICAL";
    case PanoramaMode_Enum.SPHERE:
      return "SPHERE";
    case PanoramaMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TODO: Write panorama data */
export interface TakePanoramaResultData {
  numPhotosTaken: number;
  numFailedPhotos: number;
}

export interface TakePanoramaActionStateData {
}

function createBaseTakePanoramaActionArgs(): TakePanoramaActionArgs {
  return { panoramaMode: 0, cameraSettings: undefined, photoSettings: undefined };
}

export const TakePanoramaActionArgs = {
  encode(message: TakePanoramaActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.panoramaMode !== 0) {
      writer.uint32(32).int32(message.panoramaMode);
    }
    if (message.cameraSettings !== undefined) {
      CameraSettings.encode(message.cameraSettings, writer.uint32(42).fork()).ldelim();
    }
    if (message.photoSettings !== undefined) {
      PhotoSettings.encode(message.photoSettings, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakePanoramaActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakePanoramaActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          if (tag !== 32) {
            break;
          }

          message.panoramaMode = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.cameraSettings = CameraSettings.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.photoSettings = PhotoSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TakePanoramaActionArgs {
    return {
      panoramaMode: isSet(object.panoramaMode) ? panoramaMode_EnumFromJSON(object.panoramaMode) : 0,
      cameraSettings: isSet(object.cameraSettings) ? CameraSettings.fromJSON(object.cameraSettings) : undefined,
      photoSettings: isSet(object.photoSettings) ? PhotoSettings.fromJSON(object.photoSettings) : undefined,
    };
  },

  toJSON(message: TakePanoramaActionArgs): unknown {
    const obj: any = {};
    if (message.panoramaMode !== 0) {
      obj.panoramaMode = panoramaMode_EnumToJSON(message.panoramaMode);
    }
    if (message.cameraSettings !== undefined) {
      obj.cameraSettings = CameraSettings.toJSON(message.cameraSettings);
    }
    if (message.photoSettings !== undefined) {
      obj.photoSettings = PhotoSettings.toJSON(message.photoSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TakePanoramaActionArgs>, I>>(base?: I): TakePanoramaActionArgs {
    return TakePanoramaActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakePanoramaActionArgs>, I>>(object: I): TakePanoramaActionArgs {
    const message = createBaseTakePanoramaActionArgs();
    message.panoramaMode = object.panoramaMode ?? 0;
    message.cameraSettings = (object.cameraSettings !== undefined && object.cameraSettings !== null)
      ? CameraSettings.fromPartial(object.cameraSettings)
      : undefined;
    message.photoSettings = (object.photoSettings !== undefined && object.photoSettings !== null)
      ? PhotoSettings.fromPartial(object.photoSettings)
      : undefined;
    return message;
  },
};

function createBasePanoramaMode(): PanoramaMode {
  return {};
}

export const PanoramaMode = {
  encode(_: PanoramaMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PanoramaMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePanoramaMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PanoramaMode {
    return {};
  },

  toJSON(_: PanoramaMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PanoramaMode>, I>>(base?: I): PanoramaMode {
    return PanoramaMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PanoramaMode>, I>>(_: I): PanoramaMode {
    const message = createBasePanoramaMode();
    return message;
  },
};

function createBaseTakePanoramaResultData(): TakePanoramaResultData {
  return { numPhotosTaken: 0, numFailedPhotos: 0 };
}

export const TakePanoramaResultData = {
  encode(message: TakePanoramaResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.numPhotosTaken !== 0) {
      writer.uint32(8).int32(message.numPhotosTaken);
    }
    if (message.numFailedPhotos !== 0) {
      writer.uint32(16).int32(message.numFailedPhotos);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakePanoramaResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakePanoramaResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.numPhotosTaken = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.numFailedPhotos = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TakePanoramaResultData {
    return {
      numPhotosTaken: isSet(object.numPhotosTaken) ? globalThis.Number(object.numPhotosTaken) : 0,
      numFailedPhotos: isSet(object.numFailedPhotos) ? globalThis.Number(object.numFailedPhotos) : 0,
    };
  },

  toJSON(message: TakePanoramaResultData): unknown {
    const obj: any = {};
    if (message.numPhotosTaken !== 0) {
      obj.numPhotosTaken = Math.round(message.numPhotosTaken);
    }
    if (message.numFailedPhotos !== 0) {
      obj.numFailedPhotos = Math.round(message.numFailedPhotos);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TakePanoramaResultData>, I>>(base?: I): TakePanoramaResultData {
    return TakePanoramaResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakePanoramaResultData>, I>>(object: I): TakePanoramaResultData {
    const message = createBaseTakePanoramaResultData();
    message.numPhotosTaken = object.numPhotosTaken ?? 0;
    message.numFailedPhotos = object.numFailedPhotos ?? 0;
    return message;
  },
};

function createBaseTakePanoramaActionStateData(): TakePanoramaActionStateData {
  return {};
}

export const TakePanoramaActionStateData = {
  encode(_: TakePanoramaActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakePanoramaActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakePanoramaActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TakePanoramaActionStateData {
    return {};
  },

  toJSON(_: TakePanoramaActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TakePanoramaActionStateData>, I>>(base?: I): TakePanoramaActionStateData {
    return TakePanoramaActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakePanoramaActionStateData>, I>>(_: I): TakePanoramaActionStateData {
    const message = createBaseTakePanoramaActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
